module.exports = __webpack_public_path__ + "media/cheers-with-fadeout.f7399ff9.mp3";